import React, { useState, useEffect } from 'react'
import { Button, Space } from 'antd'
import { Moment } from '../../../helpers'
import ColumnGroup from 'antd/lib/table/ColumnGroup'
import './style.scss'
import { DashOutlined } from '@ant-design/icons'
export const JobTime = (props) => {
  const [fontcolor, setFontColor] = useState()
  const [date1, setDate1] = useState()
  const [date2, setDate2] = useState()
  const [time1, setTime1] = useState(null)
  const [time2, setTime2] = useState(null)
  const jobStatus = props.data.job_status
  useEffect(() => {
    const d1 = Moment(props.data.start_time).utc(7)
    const d2 = Moment(props.data.end_time).utc(7)
    if (d1.isValid()) {
      setDate1(d1.format('ll'))
      setTime1(d1.format('LT'))
    }
    if (d2.isValid()) {
      setDate2(d2.format('ll'))
      setTime2(d2.format('LT'))
    }
  })

  const showTime = () => {
    if (date1 && date2) {
      // ถ้าวันเดียวกัน
      if (date1 == date2) {
        const timeFormat1 = <span className="time">{time1} น.</span>
        const timeFormat2 = (
          <span className="time">
            {time1} - {time2} น.
          </span>
        )
        return (
          <>
            <div>
              <span className="date">{date1}</span>,{' '}
              {time1 == time2 ? timeFormat1 : timeFormat2}
            </div>
          </>
        )
      }
      // คนละวัน
      else {
        return (
          <>
            <span>
              <span className="date">{date1}</span>,{' '}
              <span className="time">{time1} น.</span>
            </span>
            <span style={{ margin: '0 7px' }}> - </span>
            <span>
              <span className="date">{date2}</span>,{' '}
              <span className="time">{time2} น.</span>
            </span>
          </>
        )
      }
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: 'inline-block',
          borderColor: jobStatus == 1 ? 'green' : '#222222',
        }}
      >
        {showTime()}
      </div>
    </React.Fragment>
  )
}
